// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignRightOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignRightOutlined";
import AntdIcon from '../components/AntdIcon';

var AlignRightOutlined = function AlignRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignRightOutlinedSvg
  }));
};

AlignRightOutlined.displayName = 'AlignRightOutlined';
export default React.forwardRef(AlignRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlignRightOutlined.js
// module id = 541
// module chunks = 0